import { useNavigate } from 'react-router-dom';

export default function Services() {
  const navigate = useNavigate();

  const services = [
    {
      icon: 'ri-building-line',
      title: 'Office Cleaning',
      description: 'Complete office cleaning solutions including desks, floors, restrooms, and common areas. Daily, weekly, or custom schedules available.',
      features: ['Desk & Surface Cleaning', 'Floor Care', 'Restroom Sanitization', 'Kitchen Cleaning'],
      link: '/services/office-cleaning'
    },
    {
      icon: 'ri-store-2-line',
      title: 'Retail Cleaning',
      description: 'Keep your retail space spotless and inviting for customers. Flexible scheduling to work around your business hours.',
      features: ['Floor Maintenance', 'Window Cleaning', 'Display Dusting', 'Entrance Care'],
      link: '/services/retail-cleaning'
    },
    {
      icon: 'ri-hospital-line',
      title: 'Medical Facility Cleaning',
      description: 'Specialized cleaning for healthcare environments with strict sanitation protocols and medical-grade disinfectants.',
      features: ['Medical-Grade Disinfection', 'Biohazard Handling', 'HIPAA Compliance', 'Infection Control'],
      link: '/services/medical-facility-cleaning'
    },
    {
      icon: 'ri-home-office-line',
      title: 'Industrial Cleaning',
      description: 'Heavy-duty cleaning for warehouses, factories, and industrial facilities. Equipment and expertise for large-scale operations.',
      features: ['Warehouse Cleaning', 'Equipment Cleaning', 'High-Pressure Washing', 'Safety Compliance'],
      link: '/services/industrial-cleaning'
    },
    {
      icon: 'ri-window-line',
      title: 'Window Cleaning',
      description: 'Professional interior and lower-level window cleaning for buildings of all sizes. Streak-free results every time.',
      features: ['Interior Windows', 'Lower-Level Exteriors', 'Streak-Free Finish', 'Frame Cleaning'],
      link: '/services/window-cleaning'
    },
    {
      icon: 'ri-tools-line',
      title: 'Specialized Services',
      description: 'Deep cleaning, carpet cleaning, floor waxing, and post-construction cleanup. Custom solutions for unique needs.',
      features: ['Deep Cleaning', 'Carpet Shampooing', 'Floor Waxing', 'Post-Construction'],
      link: '/services/specialized-services'
    }
  ];

  return (
    <section id="services" className="py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-800 mb-4 font-['Poppins']">
            Our <strong className="text-teal-500">Cleaning Services</strong>
          </h2>
          <div className="w-16 h-1 bg-teal-500 mx-auto mb-6"></div>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Comprehensive commercial cleaning solutions tailored to your business needs. Professional, reliable, and eco-friendly services.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              onClick={() => navigate(service.link)}
              className="bg-white rounded-2xl p-8 hover:shadow-xl transition-all duration-300 group cursor-pointer border border-slate-100"
            >
              {/* Icon */}
              <div className="w-16 h-16 flex items-center justify-center bg-teal-50 rounded-xl mb-6 group-hover:bg-teal-500 transition-colors duration-300">
                <i className={`${service.icon} text-3xl text-teal-500 group-hover:text-white transition-colors duration-300`}></i>
              </div>

              {/* Title */}
              <h3 className="text-xl font-bold text-slate-800 mb-3">
                {service.title}
              </h3>

              {/* Description */}
              <p className="text-slate-600 mb-6 leading-relaxed">
                {service.description}
              </p>

              {/* Features */}
              <ul className="space-y-2 mb-6">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center gap-2 text-sm text-slate-600">
                    <i className="ri-check-line text-teal-500"></i>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>

              {/* Learn More Button */}
              <div className="flex items-center gap-2 text-teal-500 font-semibold group-hover:gap-3 transition-all duration-300">
                <span>Learn More</span>
                <i className="ri-arrow-right-line"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
